import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoggingService } from 'src/app/services/consoleLogs';

@Injectable({
  providedIn: 'root'
})
export class UpgradePopupService {

  constructor(private loggingService : LoggingService) { }
  private showPopupSource = new BehaviorSubject<boolean>(false);
  private featuresSource = new BehaviorSubject<string[]>([]);
  private componentNameSource = new BehaviorSubject<string>('');

  showPopup$ = this.showPopupSource.asObservable();
  features$ = this.featuresSource.asObservable();
  componentName$ = this.componentNameSource.asObservable();

  private showADPopupSource = new BehaviorSubject<boolean>(false);
  private featuresADSource = new BehaviorSubject<string[]>([]);
  private componentADNameSource = new BehaviorSubject<string>('');

  showADPopup$ = this.showADPopupSource.asObservable();
  featuresAD$ = this.featuresADSource.asObservable();
  componentADName$ = this.componentADNameSource.asObservable();

  showPaymentPopup(message: string, componentName: string = ''): void {
    this.loggingService.log('loading');
    
    const features = message
      .split('\\n')
      .map(line => line.trim())
      .filter(line => line.length > 0);
    this.loggingService.log(features);
    
    this.featuresSource.next(features.length ? features : ['Access restricted. Please upgrade your plan.']);
    this.componentNameSource.next(componentName);
    this.loggingService.log(componentName);
    
    this.showPopupSource.next(true);
  }

  showAccessDenied(message: string, componentName: string = ''): void {
    const features = message
      .split('\\n')
      .map(line => line.trim())
      .filter(line => line.length > 0);

    this.featuresADSource.next(features.length ? features : ['Access restricted.']);
    this.componentADNameSource.next(componentName);
    this.showADPopupSource.next(true);
  }

  closePaymentPopup(): void {
    this.showPopupSource.next(false);
    this.componentNameSource.next('');
  }
}
  